// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"b597eed6","787":"8317a02d"}[chunkId] + ".chunk.js";
};